<app-spinner [isLoading]="isLoading" *ngIf="isLoading"></app-spinner>
<div class="w-100 d-flex flex-column gap-4 justify-content-between align-items-center gap-3">

  <div class="col-sm-12">
    <div class="d-flex flex-wrap w-100">
      <div class="d-flex flex-column gap-0 w-50">
        <label class="form-label">{{
          "forms.email" | translate
          }}</label>
        <p class="mb-0">{{ user.email }}</p>
      </div>
    </div>
  </div>
  <div class="col-sm-12">
    <div class="d-flex flex-wrap w-100">
      <div class="d-flex flex-column gap-0 w-50">
        <label class="form-label">{{
          "forms.role" | translate
          }}</label>
        <p class="mb-0">{{ "roles.store_manager" | translate }}</p>
        <!-- <div [ngSwitch]="user.role">
          <p class="mb-0" *ngSwitchCase="Roles.Admin">{{ 'roles.admin' | translate }}</p>
          <p class="mb-0" *ngSwitchCase="Roles.StoreManager">{{ 'roles.store_manager' | translate }}</p>
          <p class="mb-0" *ngSwitchCase="Roles.KAM">{{ 'roles.kam' | translate }}</p>
        </div> -->
      </div>
    </div>
  </div>
  <hr class="separator" />

  <div class="col-sm-12">
    <button data-test="logout-button" class="btn btn-primary" type="button" (click)="logout()">
      {{ 'button_labels.logout' | translate }}
    </button>
  </div>
</div>
